import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'newline'
})
export class NewlinePipe implements PipeTransform {

    transform(value: string, args?: any): any {
        return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
}



// WEBPACK FOOTER //
// ./src/app/brightserve/pipes/newline.pipe.ts